import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';

import { City } from '../location/model/city.model';
import { PostalCode } from '../location/model/postal-code.model';
import { State } from '../location/model/state.model';
import { Address } from './address';

import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';

import { PartyRoleTypes } from '../../party/model/party-role-types.model';

import { GeographicalRegions } from '../../party/model/geographicalRegions.model';
import { MatPaginator } from '@angular/material/paginator';

import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { PCMEditInterface } from '../model/pcm-edit-interfacte';
import { AccessService } from '../../navigation/service/access.service';
import { CoeRelatedStudent, STUDENT } from '../multi-select-coe-student/coe-related-student';
import { StudentService } from '../../children/service/student.service';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = AddressColumns.map((col) => col.key);
    columnsSchema: any = AddressColumns;
    dataSource = new MatTableDataSource<Address>();

    contactMechanismType: ContactMechanismTypes;
    contactMechanismPurposeTypes: ContactMechanismPurposeTypes[] = [];
    relatedPartyContactMechStudents: STUDENT[] = [];
    geographicalRegions: GeographicalRegions[] = [];

    kidsInfoByCoe: boolean = false;
    CoeRelatedStudents: CoeRelatedStudent[] = [];
    result: CoeRelatedStudent[] = [];

    coeChildSpinner: boolean = false;

    city = new City();
    state = new State();
    zipCode = new PostalCode();
    initialPartyContactMech: PartyContactMechanisms;
    partyRoleType: PartyRoleTypes;
    lstAddressdata: Address[] = [];

    @Input() type!: 'People' | 'Organization' | 'Student';
    @Input() filterTypes: string[] = [];
    @Input() refresh: boolean = false;
    @Input() initialCoeRelatedStudents: CoeRelatedStudent[] = [];
    @Input() data: PartyContactMechanisms[] = [];
    @Input() partyId: number = 0;
    @Input() readOnly: boolean = false;
    @Input() editing: boolean;

    @Output() partyContactMechanismsChange: EventEmitter<PCMEditInterface> = new EventEmitter<PCMEditInterface>();

    constructor(
        public dialog: MatDialog,
        //private contactMechanismsService: ContactMechanismsService,
        //private partyRolesService: PartyRolesService,
        private accessService: AccessService,
        private studentService: StudentService
    ) {}
    ngOnInit(): void {
        this.getContactMechanismTypes();
        this.getContactMechanismPurposeTypes();
        this.getPartyRoleType();
        this.getGeographicalRegion();
        //this.getCoeRelatedStudents();
    }
    populateAddressData() {
        this.lstAddressdata = [];
        const type = this.type === 'People' || '' ? 'Person' : this.type;
        if (this.data) {
            const now = new Date().getTime();

            let filterParyContanctMechanisms: PartyContactMechanisms[] = this.data.filter(
                (x) => (x.CONTACT_MECHANISMS?.CONTACT_MECHANISM_TYPES?.TYPE === 'Address' 
                        && (x.PARTY_ROLE_TYPES?.TYPE == type || x.PARTY_ROLE_TYPES?.TYPE == 'Employee'))
            );
            filterParyContanctMechanisms.forEach((p) => (p.CREATED_DATE = new CleanDatePipe().transform(p.CREATED_DATE!)));

            filterParyContanctMechanisms.sort((a, b) => {
                return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
            });

            filterParyContanctMechanisms.forEach((element) => {
                this.lstAddressdata.push({ isEdit: false, partyContactMechanisms: element });
            });
        }
        this.dataSource.data = this.lstAddressdata;
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.populateAddressData();
        this.kidsInfoByCoe = false;
    }
    addRow() {
        this.kidsInfoByCoe = true;
        this.relatedPartyContactMechStudents = [];
        this.CoeRelatedStudents = JSON.parse(JSON.stringify(this.initialCoeRelatedStudents));
        this.dataSource.data.findIndex((x) => x.isEdit == true) == -1
            ? (this.dataSource.data = [{ isEdit: true, partyContactMechanisms: this.buildContactMechanisms() }, ...this.dataSource.data])
            : null;

        this.ngAfterViewInit();
    }

    editRow(row: Address) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            this.CoeRelatedStudents = JSON.parse(JSON.stringify(this.initialCoeRelatedStudents));
            if (!this.kidsInfoByCoe) this.kidsInfoByCoe = true;
            if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
                this.initialPartyContactMech = new PartyContactMechanisms();
                this.initialPartyContactMech = JSON.parse(JSON.stringify(row.partyContactMechanisms));                
                row.isEdit = true;
            }
        }
    }

    updateRow(row: Address) {
        this.kidsInfoByCoe = false;
        row.isEdit = false;
        this.state = new State();
        /*if (this.relatedPartyContactMechStudents.length > 0)
        {
            this.relatedPartyContactMechStudents.forEach(
                x=>x.PERSON.PARTy.PARTY_CONTACT_MECHANISMS=[this.initialPartyContactMech]);
            row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS = this.relatedPartyContactMechStudents;            
            
        } */ 
        let requestPayload = { party: { ID: this.partyId }, partyContactMechanism: row.partyContactMechanisms };
        this.studentService.getCoeRelatedStudentsByContactMechanism(requestPayload).subscribe((x) => {
            if (x['coes'] === undefined) {
                if (x['msg'] !== undefined) {
                    //this.msg = x['msg'];
                    this.CoeRelatedStudents = [];
                    this.coeChildSpinner = false;
                }
            } else {
                //if (!this.kidsInfoByCoe) this.kidsInfoByCoe = true;
                this.CoeRelatedStudents = JSON.parse(x['coes']);
                this.result = JSON.parse(x['coes']);
                this.coeChildSpinner = false;
                row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS = [];
                this.result.forEach((s: any) => {
                    s.COE_STUDENTS.forEach((cs: any) => {
                        if (this.relatedPartyContactMechStudents.length > 0) {
                           this.relatedPartyContactMechStudents.forEach(x => {
                                if (x.PERSONS_ID === cs.STUDENT?.PERSON?.ID) {
                                    row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS?.push(cs.STUDENT)
                                }
                            });
                        }
                    })
                });
            }
        });
        this.emitdataSource(undefined, row.partyContactMechanisms.ID);
    }

    RemoveCallCoeRelatedStudents(row: Address) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            if (row.partyContactMechanisms.ID! < 0) {
                this.deleteRow(row);
            } else {
                this.CoeRelatedStudents = [];
                this.coeChildSpinner = true;
                this.kidsInfoByCoe = true;
                this.initialPartyContactMech = new PartyContactMechanisms();
                this.initialPartyContactMech = JSON.parse(JSON.stringify(row.partyContactMechanisms));

                row.isEdit = true;
                row.isDelete = true;

                let requestPayload = { party: { ID: this.partyId }, partyContactMechanism: row.partyContactMechanisms };

                this.studentService.getCoeRelatedStudentsByContactMechanism(requestPayload).subscribe((x) => {
                    if (x['coes'] === undefined) {
                        if (x['msg'] !== undefined) {
                            //this.msg = x['msg'];
                            this.CoeRelatedStudents = [];
                            this.coeChildSpinner = false;
                        }
                    } else {
                        //if (!this.kidsInfoByCoe) this.kidsInfoByCoe = true;
                        this.coeChildSpinner = false;
                        this.CoeRelatedStudents = JSON.parse(x['coes']);
                    }
                });
            }
        }
    }

    deleteRow(row: Address) {
        let id = row.partyContactMechanisms.ID;
        let removedItem = this.dataSource.data.find((u: Address) => u.partyContactMechanisms.ID == id);
        this.dataSource.data = this.dataSource.data.filter((u: Address) => u.partyContactMechanisms.ID !== id);
        this.state = new State();
        if (this.relatedPartyContactMechStudents.length > 0)
            row.partyContactMechanisms.RELATED_PARTY_CONTACT_MECHANISM_STUDENTS = this.relatedPartyContactMechStudents;
        //exiting record deleted then notify otherwise send null
        if (removedItem?.partyContactMechanisms.ID! > 0) {
            this.emitdataSource(removedItem?.partyContactMechanisms, id);
        } else {
            this.emitdataSource(undefined, id);
        }

        this.kidsInfoByCoe = false;
        row.isEdit = false;
        row.isDelete = false;
        this.coeChildSpinner = false;
    }

    cancelRow(row: Address) {
        this.kidsInfoByCoe = false;
        this.state = new State();
        row.isEdit = false;
        row.isDelete = false;
        this.coeChildSpinner = false;
        //revert back to original state
        //get the original data from addressData and update the row else remove the data.
        let address = this.lstAddressdata.find((x) => x.partyContactMechanisms.ID === row.partyContactMechanisms.ID);

        if (address != undefined && address.partyContactMechanisms.ID! > 0) {
            row.partyContactMechanisms = this.initialPartyContactMech;
        } else {
            this.dataSource.data = this.dataSource.data.filter((u: Address) => u.partyContactMechanisms.ID !== row.partyContactMechanisms.ID);
        }
    }

    disableSubmit(row: Address) {
        if (
            row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE &&
            row.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0]?.STREET_1 &&
            row.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0]?.CITy?.ID &&
            row.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0]?.CITy?.STATE!.ID &&
            row.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0]?.POSTAL_CODES?.ID
        ) {
            return false;
        } else return true;
    }

    determineEditRow(row: Address) {
        if (row.partyContactMechanisms?.ID! > 0) {
            let purposeType = row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE;

            let filterParyContanctMechanisms: Address[] = this.lstAddressdata.filter(
                (x) => x.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE === purposeType
            );
            return filterParyContanctMechanisms.findIndex((x) => x.partyContactMechanisms.ID === row.partyContactMechanisms.ID) >= 1 ? false : true;
            //return this.lstAddressdata.findIndex((x) => x.partyContactMechanisms.ID === row.partyContactMechanisms.ID) >= 1 ? false : true;
        } else {
            return true;
        }
    }

    buildContactMechanisms(): PartyContactMechanisms {
        const arrPCMId = this.toNumberArray(this.dataSource.data);

        let min = arrPCMId.length > 0 ? arrPCMId.reduce((a, b) => Math.min(a, b)) : 0;

        min = min > 0 ? -1 : min - 1;

        let tempPCM = new PartyContactMechanisms();
        tempPCM = {
            ID: min,
            PARTY_ROLE_TYPES: this.partyRoleType,
            CONTACT_MECHANISMS: {
                CONTACT_MECHANISM_TYPES: this.contactMechanismType,
                POSTAL_ADDRESSES: [
                    {
                        GEOGRAPHICAL_REGIONS: this.geographicalRegions[0],
                        STREET_1: '',
                        STREET_2: '',
                        CITy: {
                            STATE: {
                                ID: 0,
                                COUNTRIES_ID: 0,
                                STATE_NAME: '',
                                STATE_CODE: '',
                                COUNTRy: {
                                    ID: 1
                                }
                            }
                        },
                        POSTAL_CODES: {}
                    }
                ]
            },
            PARTY_CONTACT_MECHANISM_PURPOSES: [
                { 
                    CONTACT_MECHANISM_PURPOSE_TYPES: {
                        ID:0,
                        TYPE: '',                    
                        DESCRIPTION:''
                    } 
                }
            ]
        };
        return tempPCM;
    }

    compareFn(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }
        return o1?.ID === o2?.ID;
    }

    //This event  will be triggered by
    //1) updateRow(row: Address) for  Add/Modify Action
    //2) removeRow(id: number)   for  Delete Action

    //Todo : Refactor to notify only the delta changes.
    emitdataSource(removedItem?: PartyContactMechanisms, id?: number) {
        let eventChangedPCM: PartyContactMechanisms[] = this.dataSource.data.map((x) => x.partyContactMechanisms);

        this.partyContactMechanismsChange.emit({ editpartyContactMechanisms: eventChangedPCM, deletePartyContactMechanisms: removedItem });
    }

    coeStudentsEventEmitter(relatedContactMechStudents: STUDENT[]) {        
        this.relatedPartyContactMechStudents = relatedContactMechStudents;                        
    }

    //Change this API service to read from ngrx store
    getContactMechanismTypes() {
        this.accessService.getContactMechanism().subscribe((res: ContactMechanismTypes[]) => {
            let responseContactMechanismTypes: ContactMechanismTypes[] = res;
            this.contactMechanismType = responseContactMechanismTypes.find((x) => x.TYPE === 'Address')!;
        });
        /*this.contactMechanismsService.indexContactMechanismTypes().subscribe((res: any) => {
            let responseContactMechanismTypes: ContactMechanismTypes[] = res.contactMechanismTypes;
            this.contactMechanismType = responseContactMechanismTypes.find((x) => x.TYPE === 'Address')!;
        });*/
    }

    getContactMechanismPurposeTypes() {
        this.accessService.getContactMechanismPurpose().subscribe((res: ContactMechanismPurposeTypes[]) => {
            let a: ContactMechanismPurposeTypes[] = res;
            this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
        });
        /*this.contactMechanismsService.indexContactMechanismPurposeTypes().subscribe((res: any) => {
            let a: ContactMechanismPurposeTypes[] = res.contactMechanismPurposeTypes;
            this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
        });*/
    }

    getPartyRoleType() {
        const type = this.type === 'People' || '' ? 'Person' : this.type;
        this.accessService.getPartyRoleTypes().subscribe((res: PartyRoleTypes[]) => {
            let prType = res.find((x: PartyRoleTypes) => x.TYPE === type);
            if (prType != undefined && prType.ID > 0) {
                this.partyRoleType = prType;
            }
        });

        /*this.partyRolesService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
            const type = this.type === 'People' || '' ? 'Person' : this.type;

            this.partyRoleType = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === type;
            });
        });*/
    }
    getGeographicalRegion() {
        this.accessService.getGeographical().subscribe((res: GeographicalRegions[]) => {
            this.geographicalRegions = res;
        });

        /*this.contactMechanismsService.indexGeographicalRegions().subscribe((res: any) => {
            this.geographicalRegions = res.geographicalRegions;
        });*/
    }

    toNumberArray(array: Address[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.partyContactMechanisms.ID ? returnArray.push(obj.partyContactMechanisms.ID) : null;
        });

        return returnArray;
    }

    getCoeRelatedStudents() {
        let coeRelatedStudentPayload: any = { party: { ID: this.partyId } };

        this.studentService.getCoeRelatedStudents(coeRelatedStudentPayload).subscribe((x) => {
            if (x['coes'] === undefined) {
                if (x['msg'] !== undefined) {
                    this.initialCoeRelatedStudents = [];
                }
            } else {
                this.initialCoeRelatedStudents = JSON.parse(x['coes']);
            }
        });
    }
}

export const AddressColumns = [
    {
        key: 'isEdit',
        type: 'boolean',
        label: ''
    },
    {
        key: 'activeDate',
        type: 'date',
        label: 'Active Date'
    },
    {
        key: 'addressType',
        type: 'text',
        label: 'Address Type'
    },
    {
        key: 'address',
        type: 'text',
        label: 'Address',
        required: true
    }
    
];
